import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import {
  dashboardSelector,
  GetdashboardDetails,
} from "../../features/dashboard/dashboardSlice";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../orderStatus/Loader";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useState } from "react";
import parse from "html-react-parser";
import { languageSelector } from "../../features/language/languageSlice";
import {
  GetFirmByUserID,
  manageBillingSelector,
  setFirmIDAndName,
} from "../../features/managebilling/manageBillingSlice";
import { GetAllNotificationsForUser } from "../../features/notes/notesSlice";
import {
  GetFirmByFileID,
  GetLawFirmsByName,
  GetLawfirmsByNameExpress,
  lawFirmSelector,
  setAllFirmDetails,
  setDashboardLawfirm,
  setIsDashBoardLawfirmSelected,
} from "../../features/lawFirm/lawFirmSlice";
import CustomAutoCompleteTextSelect from "../../components/global/CustomSelect/CustomAutoCompleteTextSelect";
import { useForm } from "react-hook-form";
import SelectFormField from "../../components/global/SelectFormField/SelectFormField";
import http from "../../common/cticApi";
import { debounce } from "lodash";
import {
  setFileDetailsInfo,
  setPostOrderDetailsInfo,
} from "../../features/auth/orderLawyerInformationSlice";
import { setEditOrderDetails } from "../../features/ordersSummary/orderSummarySlice";
import CryptoJS from "crypto-js";
import { getRandomSearchText } from "../../common/utils";

export default function Dashboard() {
  const { userLogin } = useSelector(authLoginSelector);
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth();
  let dd = today.getDate();
  const dispatch = useDispatch();

  const { loading, dashboardDetails, searchResults } =
    useSelector(dashboardSelector);
  const lang = useSelector(languageSelector);
  const { firmIDAndName } = useSelector(manageBillingSelector);

  if (dd < 10) dd = "0" + dd;
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const isFileOpenedfromTT = window.localStorage.getItem("isFileOpenedfromTT");
  const [specialLatestNews, setspecialLatestNews] = useState([]);
  const [lawfirmloading, setlawfirmloading] = useState(false);
  const [firmOptions, setFirmOptions] = useState([
    { value: firmIDAndName?.firmID, label: firmIDAndName?.firmName },
  ]);
  // console.log("?? ~ Dashboard ~ firmOptions:", firmOptions);
  const [defaultLawfirmOption, setdefaultLawfirmOption] = useState(
    firmIDAndName?.firmName,
  );
  const [isDashboardLawfirmSelected, setisDashboardLawfirmSelected] =
    useState(false);
  const [dashboardLawfirm, setdashboardLawfirm] = useState({
    FirmID: "",
    FirmName: "",
    HasFirmBilling: "",
  });
  const navigate = useNavigate();
  const { AllFirmDetails, multipleLawFirms } = useSelector(lawFirmSelector);
  const {
    DashboardLawfirm,
    IsDashBoardLawfirmSelected,
    FileFirmDetails,
    multipleFirmsUser,
  } = useSelector(lawFirmSelector);
  // console.log("?? ~ Dashboard ~ DashboardLawfirm:", DashboardLawfirm);

  const {
    register,
    handleSubmit,
    reset,
    setFocus,
    setError,
    clearErrors,
    setValue,
    getValues,
    watch,
    trigger,
    control,
    formState: { errors },
  } = useForm();

  watch("dashboardLawfirm");
  const onDynamicSearch = (value) => {
    setlawfirmloading(true);
    value?.length > 2 && dispatch(GetLawfirmsByNameExpress(value, true));
    setlawfirmloading(false);
  };

  const values = getValues();
  // console.log("?? ~ Dashboard ~ values:", values);
  const dropdownChange = (e, name, _standardQuestionName, selectedOption) => {
    let selectedId;
    if (
      !e &&
      e === 0 &&
      localStorage?.getItem("selectedFirmId") &&
      localStorage?.getItem("selectedFirmId") !== 0
    ) {
      selectedId = localStorage?.getItem("selectedFirmId");
    } else {
      selectedId = e;
    }
    if (selectedId === 0 || selectedId == undefined || !selectedId) {
      return;
    }

    setValue(name, selectedId?.toString());
    setisDashboardLawfirmSelected(true);
    dispatch(setIsDashBoardLawfirmSelected(true));
    trigger(name);

    // When the user picks from an async search, firmOptions may not contain the
    // searched firm yet. Use the full option object passed by AsyncSelect.onChange
    // (4th arg) first; fall back to firmOptions lookup for non-async call sites.
    const matchedOption =
      selectedOption ?? firmOptions?.find((x) => x?.value === selectedId);

    const newDashboardLawfirm = {
      FirmName: matchedOption?.label,
      FirmID: selectedId,
      HasFirmBilling: matchedOption?.hasFirmBilling,
    };

    setdashboardLawfirm(newDashboardLawfirm);
    // Use the local variable — setdashboardLawfirm is async so the state
    // value would still be stale here if we read dashboardLawfirm directly.
    dispatch(setDashboardLawfirm(newDashboardLawfirm));
    localStorage?.setItem("selectedFirmId", selectedId);
    if (newDashboardLawfirm?.FirmName)
      localStorage?.setItem("selectedFirm", newDashboardLawfirm?.FirmName);
  };

  useEffect(() => {
    dispatch(setPostOrderDetailsInfo(null));
    dispatch(setFileDetailsInfo(null));
    if (
      localStorage?.getItem("selectedFirmId") !== undefined &&
      localStorage?.getItem("selectedFirmId") !== null &&
      localStorage?.getItem("selectedFirmId") > 0
    ) {
      dispatch(setIsDashBoardLawfirmSelected(true));
      setisDashboardLawfirmSelected(true);
    } else {
      dispatch(setIsDashBoardLawfirmSelected(false));
      setisDashboardLawfirmSelected(false);
    }
  }, []);
  //watch(dashboardLawfirm);
  useEffect(() => {
    if (
      dashboardLawfirm &&
      dashboardLawfirm !== null &&
      dashboardLawfirm?.FirmID !== ""
    ) {
      dispatch(setDashboardLawfirm(dashboardLawfirm));
    }
  }, [DashboardLawfirm, dashboardLawfirm]);

  useEffect(() => {
    if (userLogin?.internalUser) {
      dispatch(
        GetLawfirmsByNameExpress(
          localStorage.getItem("selectedFirm") !== undefined && //getRandomSearchText will get the random text from firmname so that in dropdown there will be multiple option filled default instead of single option.
            localStorage.getItem("selectedFirm") !== null
            ? getRandomSearchText(localStorage.getItem("selectedFirm"))
            : "test",
          true,
        ),
      ); // this is just to fill the dropdown initially so that its not empty for user
    } else if (userLogin?.userLawFirms && userLogin?.userLawFirms?.length > 0) {
      dispatch(setAllFirmDetails(userLogin?.userLawFirms));
    }
    if (
      DashboardLawfirm &&
      DashboardLawfirm !== null &&
      DashboardLawfirm?.FirmID !== ""
    ) {
      const encryptedLawfirm = window.localStorage.getItem("dashboardLawFirm");
      let decryptedLawfirm = null;
      if (encryptedLawfirm) {
        const decryptedBytes = CryptoJS.AES.decrypt(
          encryptedLawfirm,
          process.env.REACT_APP_CRYPTO_KEY,
        );
        decryptedLawfirm = JSON.parse(
          decryptedBytes.toString(CryptoJS.enc.Utf8),
        );
      }
      setValue(
        "dashboardLawfirm",
        DashboardLawfirm?.FirmID?.toString() ||
          decryptedLawfirm?.FirmID?.toString(),
      );
    }
    if (FileFirmDetails == null) {
      dispatch(
        GetFirmByFileID(
          parseInt(window.localStorage.getItem("TTFileID")),
          userLogin?.userId,
        ),
      );
    }
  }, []);

  useEffect(() => {
    if (AllFirmDetails && AllFirmDetails !== null) {
      setlawfirmloading(true);

      setFirmOptions(
        AllFirmDetails?.map((firm, index) => ({
          value: firm?.firmID?.toString(),
          label: firm?.firmName,
          hasFirmBilling: firm?.hasFirmBilling,
        })),
      );
      setlawfirmloading(false);
    }
  }, [AllFirmDetails]);

  useEffect(() => {
    if (dashboardDetails?.length === 0 && firmIDAndName?.firmID > 0) {
      dispatch(
        GetdashboardDetails(
          firmIDAndName?.firmID,
          lang?.value === "fr" ? "fr-ca" : "en-ca",
        ),
      );
    } else {
      setspecialLatestNews(
        dashboardDetails?.specialNews?.concat(dashboardDetails?.latestNews),
      );
    }
    dispatch(GetAllNotificationsForUser(userLogin.userId));
  }, [dashboardDetails, firmIDAndName]);

  // console.log("?? ~ useEffect ~ userLogin:", userLogin);

  useEffect(() => {
    if (firmIDAndName === null) {
      dispatch(GetFirmByUserID(userLogin?.userId));
    } else {
      if (!userLogin?.internalUser) {
        localStorage.setItem("selectedFirmId", firmIDAndName?.firmID);
      }
      // if(isFileOpenedfromTT!==undefined && isFileOpenedfromTT!=="" && isFileOpenedfromTT!==null)
      // {
      //   setFirmOptions([{ value: firmIDAndName?.firmID , label: firmIDAndName?.firmName  }])
      //   setValue('dashboardLawfirm',firmIDAndName?.firmID);
      //   setdefaultLawfirmOption(firmIDAndName?.firmName)
      // }
    }
  }, [firmIDAndName]);

  useEffect(() => {
    if (FileFirmDetails !== null) {
      //
      if (isFileOpenedfromTT === "true") {
        if (
          !localStorage?.getItem("selectedFirmId") ||
          localStorage?.getItem("selectedFirmId") ===
            FileFirmDetails?.firmID?.toString()
        ) {
          setValue("dashboardLawfirm", FileFirmDetails?.firmID?.toString());
          dropdownChange(FileFirmDetails?.firmID, "dashboardLawfirm");
          dispatch(
            setFirmIDAndName({
              firmID: FileFirmDetails?.firmID,
              firmName: FileFirmDetails?.firmName,
              hasFirmBilling: FileFirmDetails?.hasFirmBilling,
            }),
          );
        } else if (
          localStorage?.getItem("selectedFirmId") &&
          localStorage?.getItem("selectedFirmId") !== 0
        ) {
          dropdownChange(
            localStorage?.getItem("selectedFirmId")?.toString(),
            "dashboardLawfirm",
          );
        }
      }
    }
  }, [FileFirmDetails, firmOptions]);

  const checkLawfirmValidationandNavigate = (navigateRoute) => {
    if (
      userLogin?.internalUser &&
      (values?.dashboardLawfirm === "" ||
        values?.dashboardLawfirm === null ||
        values?.dashboardLawfirm === undefined)
    ) {
      setisDashboardLawfirmSelected(false);
    } else {
      // if (navigateRoute?.includes("order"))
      window.location.replace(navigateRoute);
      // else navigate(navigateRoute);
    }
  };

  const d = new Date();
  const { t } = useTranslation();
  const formattedToday = monthNames[mm] + " " + dd + ", " + yyyy;

  const loadOption = async (val) => {
    let req = {
      NameFilter: val,
      ActiveFilter: true,
    };
    let { data: response } = await http.post(
      "/Lawfirm/GetLawfirmsByNameExpress",
      req,
    );

    return response.responseObject.lawfirms?.map((firm, index) => ({
      value: firm?.firmID?.toString(),
      label: firm?.firmName,
      hasFirmBilling: firm?.hasFirmBilling,
    }));
  };

  // const debouncedLoadOptions = useMemo(() => debounce(loadOption, 1500), []);

  // console.log("LoadOptions", debouncedLoadOptions);
  console.log("isDashboardLawfirmSelected", isDashboardLawfirmSelected);
  console.log("IsDashBoardLawfirmSelected", IsDashBoardLawfirmSelected);
  console.log("SELECTED LAW FIRM: ", values["dashboardLawfirm"]);
  return (
    <>
      <div className="mt-6">
        <div className="flex mb-6 mx-[50px] mt-14">
          <div
            style={{ marginTop: "18px" }}
            className="flex-col mr-6 basis-1/2"
          >
            <div className="flex items-center justify-between">
              <h1 className="font-bold text-1xl font-montserrat">
                Welcome, {userLogin?.firstName}
              </h1>
              {(userLogin?.internalUser || multipleFirmsUser) && (
                <div className="flex mt-4">
                  <label
                    className="mr-2 mt-2"
                    for="dashboardLawfirm"
                    // { maxWidth: 200, marginTop: -7, marginRight: -7 }
                    // style={
                    //   lang?.value == "fr"
                    //     ? { fontSize: 13, marginRight: -7 }
                    //     : {}
                    // }
                  >
                    {/* Lawfirm :{" "} */}
                    {
                      // multipleFirmsUser ? "Lawfirm : " :
                      t("orderingLawFirm")
                    }
                  </label>
                  <div className="custom__dropdown-wrapper w-[388px] mb-6">
                    <SelectFormField
                      testId={`dashboardLawfirm`}
                      // label={"Lawfirm"}
                      options={firmOptions}
                      dropdownChange={dropdownChange}
                      control={control}
                      currentValue={
                        values && values["dashboardLawfirm"]
                          ? values["dashboardLawfirm"]
                          : null
                      }
                      // defaultOption={
                      //   isFileOpenedfromTT !== undefined &&
                      //     isFileOpenedfromTT !== "" &&
                      //     isFileOpenedfromTT !== null
                      //     ? FileFirmDetails?.firmName
                      //     : ""
                      // }
                      // loading={loading || isQuestionDisabledForThirdParty}
                      fieldName={`dashboardLawfirm`}
                      id={`dashboardLawfirm`}
                      // ariaLabel='Lawyer/Notary of record'
                      labelClassNames={"text-error-red font-semibold mb-2 mr-1"}
                      selectClassNames={"custom__dropdown-wrapper w-[388px]"}
                      // isSearchable={true}
                      loadOptions={loadOption}
                      isLoading={lawfirmloading}
                      //register={register}
                      errorMessage={
                        isDashboardLawfirmSelected === false ||
                        IsDashBoardLawfirmSelected === false
                          ? "* required"
                          : ""
                      }
                      isAsync
                    />
                  </div>
                </div>
              )}
            </div>
            <h2
              className="font-semibold text-[32px]"
              style={userLogin?.internalUser ? { marginTop: -18 } : {}}
            >
              {formattedToday}
            </h2>
            {dashboardDetails &&
              dashboardDetails?.announcementNews &&
              dashboardDetails?.announcementNews?.filter(
                (x) =>
                  x.languageCode === (lang?.value === "fr" ? "fr-CA" : "en-CA"),
              )?.length > 0 && (
                <div className=" rounded border border-secondary-red text-secondary-red px-6 pt-3 pb-4 mt-2">
                  {
                    <Carousel
                      showArrows={false}
                      renderArrowPrev={(onClickHandler, hasPrev, label) =>
                        hasPrev && (
                          <button
                            onClick={onClickHandler}
                            type="button"
                            className="bg-white absolute top-0 left-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none 
                    hover:bg-[/F8F8F8]
                    "
                            data-carousel-prev=""
                          >
                            <span
                              className="inline-flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 
                    bg-transparent 
                    group-hover:bg-white/50
                    hover:border-black hover:border
                    focus:border-black focus:border
                    focus-visible:border-black focus-visible:border
                    group-focus:ring-0 group-focus:ring-transparent  group-focus:outline-none "
                            >
                              <svg
                                aria-hidden="true"
                                className="w-5 h-5  sm:w-6 sm:h-6 text-gray-800"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M15 19l-7-7 7-7"
                                ></path>
                              </svg>
                              <span className="sr-only">Previous</span>
                            </span>
                          </button>
                        )
                      }
                      renderArrowNext={(onClickHandler, hasNext, label) =>
                        hasNext && (
                          <button
                            onClick={onClickHandler}
                            type="button"
                            className="bg-white absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none 
                  hover:border-black hover: hover:bg-[/F8F8F8]"
                            data-carousel-next=""
                          >
                            <span
                              className="inline-flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-transparent
                      group-hover:bg-white/50  hover:border-black hover:border
                      focus:border-black focus:border
                      focus-visible:border-black focus-visible:border
                      group-focus:ring-transparent  group-focus:outline-none "
                            >
                              <svg
                                aria-hidden="true"
                                className="w-5 h-5  sm:w-6 sm:h-6 text-gray-800"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M9 5l7 7-7 7"
                                ></path>
                              </svg>
                              <span className="sr-only">Next</span>
                            </span>
                          </button>
                        )
                      }
                      infiniteLoop
                      showThumbs={false}
                      id="indicators-carousel"
                      data-carousel="static"
                      autoFocus
                      autoPlay
                      interval={3000}
                      stopOnHover
                      showIndicators={false}
                      showStatus={false}
                    >
                      {dashboardDetails?.announcementNews
                        ?.filter(
                          (x) =>
                            x.languageCode ===
                            (lang?.value === "fr" ? "fr-CA" : "en-CA"),
                        )
                        ?.map((item, index) => (
                          <>{parse(item?.newsText)}</>
                        ))}
                    </Carousel>
                  }
                </div>
              )}
          </div>

          {!userLogin?.internalUser && (
            <div className="flex  basis-1/2">
              <div
                className={`${
                  multipleFirmsUser &&
                  (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                    ? "bg-gray-200"
                    : "bg-secondary-yellow-dashboard cursor-pointer"
                } flex items-center
                py-[28px] px-[22px] rounded text-center 
                border-2 border-transparent
                hover:border-2 hover:border-black `}
              >
                <h3
                  className="font-semibold text-1xl mt-5"
                  onClick={() => {
                    multipleFirmsUser &&
                    (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                      ? ""
                      : checkLawfirmValidationandNavigate(
                          "/orderstatus?tab=0&status=Needs Approval",
                        );
                  }}
                >
                  <span className="font-bold text-[64px] relative top-[-10px]">
                    {dashboardDetails?.needsAttentionCount}
                  </span>
                  <br />
                  {t("NeedsAttention")}
                </h3>
              </div>

              <span className="h-[152px] border relative top-[15px]"></span>

              <div
                className={`${
                  multipleFirmsUser &&
                  (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                    ? "bg-gray-200"
                    : "bg-secondary-yellow-dashboard cursor-pointer"
                } flex items-center
                py-[28px] px-[22px] rounded text-center 
                border-2 border-transparent
                hover:border-2 hover:border-black `}
              >
                <h3
                  className="font-semibold text-1xl mt-5"
                  onClick={() => {
                    multipleFirmsUser &&
                    (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                      ? ""
                      : checkLawfirmValidationandNavigate(
                          "/orderstatus?tab=0&status=Not Yet Submitted",
                        );
                  }}
                >
                  <span className="font-bold text-[64px] relative top-[-10px]">
                    {dashboardDetails?.notYetSubmittedCount}
                  </span>
                  <br />
                  {t("NotYetSubmittedOption")}
                </h3>
                <span
                  className="
                      block rounded-full bg-secondary-red text-white w-[22px] 
                      h-[22px] absolute leading-[22px] top-[35px] right-[35px]
                    "
                >
                  4
                </span>
              </div>

              <span className="h-[152px] border relative top-[15px]"></span>

              <div
                className={`${
                  multipleFirmsUser &&
                  (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                    ? "bg-gray-200"
                    : "bg-secondary-yellow-dashboard cursor-pointer"
                } flex items-center
                py-[28px] px-[22px] rounded text-center 
                border-2 border-transparent 
                hover:border-2 hover:border-black `}
              >
                <h3
                  className="font-semibold text-1xl mt-5"
                  onClick={() => {
                    multipleFirmsUser &&
                    (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                      ? ""
                      : checkLawfirmValidationandNavigate(
                          "/orderstatus?tab=0&status=Ready For Pickup",
                        );
                  }}
                >
                  <span className="font-bold text-[64px] relative top-[-10px]">
                    {dashboardDetails?.readyForPickUpCount}
                  </span>
                  <br />
                  {t("ReadyForPickupOption")}
                </h3>
              </div>
            </div>
          )}
        </div>

        <div className="flex flex-wrap gap-6 mb-8 mx-[50px]">
          <div className="flex-1 min-w-[200px] flex">
            <button
              className={`
      w-full h-full rounded bg-accordion-bg border-t-[12px] ${
        (userLogin?.internalUser || multipleFirmsUser) &&
        (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
          ? "border-grey"
          : "border-secondary-blue"
      } p-6 text-left
      border-b border-x border-b-transparent border-x-transparent
      hover:border-x-box-stroke hover:border-b hover:border-b-box-stroke hover:bg-white hover:border-x
      outline-box-stroke`}
              data-cy="orders-route-button"
              onClick={() => {
                checkLawfirmValidationandNavigate("/quote");
              }}
              disabled={
                (userLogin?.internalUser || multipleFirmsUser) &&
                (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
              }
            >
              <h3 className="font-bold text-1xl pb-[14px] border-b border-b-neutrals-black">
                {t("GetAQuote")}
              </h3>
              <p className="pt-4">{t("instantQuote")}</p>
            </button>
          </div>

          <div className="flex-1 min-w-[200px] flex">
            <button
              data-cy="ordersRouteButton"
              className={`
      w-full h-full rounded bg-accordion-bg border-t-[12px] ${
        (userLogin?.internalUser || multipleFirmsUser) &&
        (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
          ? "border-grey"
          : "border-primary-yellow"
      } p-6 text-left
      border-b border-x border-b-transparent border-x-transparent
      hover:border-x-box-stroke hover:border-b hover:border-b-box-stroke hover:bg-white outline-box-stroke`}
              onClick={() => {
                checkLawfirmValidationandNavigate("/order");
              }}
              disabled={
                (userLogin?.internalUser || multipleFirmsUser) &&
                (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
              }
            >
              <h3 className="font-bold text-1xl pb-[14px] border-b border-b-neutrals-black">
                {t("titleInsurance")}
              </h3>
              <p className="pt-4">{t("titleInsuranceSub")}</p>
            </button>
          </div>
          <div className="flex-1 min-w-[200px] flex">
            <div className="flex-1 min-w-[200px] flex">
              <button
                className={`
      w-full h-full rounded bg-accordion-bg border-t-[12px] ${
        (userLogin?.internalUser || multipleFirmsUser) &&
        (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
          ? "border-grey"
          : "border-secondary-green"
      } p-6 text-left
      border-b border-x border-b-transparent border-x-transparent
      hover:border-x-box-stroke hover:border-b hover:border-b-box-stroke hover:bg-white outline-box-stroke`}
                onClick={() => {
                  checkLawfirmValidationandNavigate("/inquiries");
                }}
                disabled={
                  (userLogin?.internalUser || multipleFirmsUser) &&
                  (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                }
              >
                <h3 className="font-bold text-1xl pb-[14px] border-b border-b-neutrals-black">
                  {t("inquiryOrders")}
                </h3>
                <p className="pt-4">{t("inquiryOrdersSub")}</p>
              </button>
            </div>
          </div>

          <div className="flex-1 min-w-[200px] flex">
            <button
              className={`w-full h-full rounded bg-accordion-bg border-t-[12px] ${
                (userLogin?.internalUser || multipleFirmsUser) &&
                (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
                  ? "border-grey"
                  : "border-secondary-burgundy"
              } p-6 text-left border-b border-x border-b-transparent border-x-transparent hover:border-x-box-stroke hover:border-b hover:border-b-box-stroke hover:bg-white outline-box-stroke`}
               onClick={() => {
                checkLawfirmValidationandNavigate("/orderstatus?tab=2");
              }}
              disabled={
                (userLogin?.internalUser || multipleFirmsUser) &&
                (!IsDashBoardLawfirmSelected || !isDashboardLawfirmSelected)
              }
            >
              <h3 className="font-bold text-1xl pb-[14px] border-b border-b-neutrals-black">
                {t("OrderStatus")}
              </h3>
              <p className="pt-4">{t("orderStatusSub")}</p>
            </button>
          </div>
        </div>
        <div style={{ minHeight: "400px" }}>
          {specialLatestNews && specialLatestNews?.length > 0 && (
            <div className="mx-[50px] mb-16 ">
              <div className="bg-neutrals-black w-full pt-4 pb-[14px] pl-10 rounded-t-md">
                <p className=" text-white font-bold font-montserrat">
                  Latest News & Special Announcements
                </p>
              </div>

              <Carousel
                showArrows={true}
                renderArrowPrev={(onClickHandler, hasPrev, label) =>
                  hasPrev && (
                    <button
                      onClick={onClickHandler}
                      type="button"
                      className="bg-white absolute top-0 left-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none 
                    hover:bg-[/F8F8F8]
                    "
                      data-carousel-prev=""
                    >
                      <span
                        className="inline-flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 
                    bg-transparent 
                    group-hover:bg-white/50
                    hover:border-black hover:border
                    focus:border-black focus:border
                    focus-visible:border-black focus-visible:border
                    group-focus:ring-0 group-focus:ring-transparent  group-focus:outline-none "
                      >
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5  sm:w-6 sm:h-6 text-gray-800"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15 19l-7-7 7-7"
                          ></path>
                        </svg>
                        <span className="sr-only">Previous</span>
                      </span>
                    </button>
                  )
                }
                renderArrowNext={(onClickHandler, hasNext, label) =>
                  hasNext && (
                    <button
                      onClick={onClickHandler}
                      type="button"
                      className="bg-white absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none 
                  hover:border-black hover: hover:bg-[/F8F8F8]"
                      data-carousel-next=""
                    >
                      <span
                        className="inline-flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-transparent
                      group-hover:bg-white/50  hover:border-black hover:border
                      focus:border-black focus:border
                      focus-visible:border-black focus-visible:border
                      group-focus:ring-transparent  group-focus:outline-none "
                      >
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5  sm:w-6 sm:h-6 text-gray-800"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5l7 7-7 7"
                          ></path>
                        </svg>
                        <span className="sr-only">Next</span>
                      </span>
                    </button>
                  )
                }
                infiniteLoop
                showThumbs={false}
                id="indicators-carousel"
                className="relative border border-[/D9D9D9;]"
                data-carousel="static"
                autoFocus
              >
                {specialLatestNews
                  ?.filter(
                    (x) =>
                      x.languageCode ===
                      (lang?.value === "fr" ? "fr-CA" : "en-CA"),
                  )
                  ?.map((item, index) => (
                    <div
                      className="relative h-[500px] overflow-hidden border border-gray-200"
                      key={index}
                    >
                      <div className="flex flex-flow pt-11 pb-16">
                        <div className="basis-1/4 pl-28 mr-6">
                          <h3 className="font-bold">
                            {item?.heading} {item?.id}
                          </h3>
                          <p>{item?.creationDate}</p>
                        </div>

                        <div className="basis-10/12 leading-[22px] pl-[74px] border-l border-black pr-[183px] ">
                          <p>{parse(item?.newsText)}</p>
                          <p>
                            <a
                              href={parse(item?.hyperLink)}
                              style={{ color: "blue" }}
                            >
                              {parse(item?.linkText)}
                            </a>{" "}
                            {parse(item?.spanText)}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
              </Carousel>
            </div>
          )}
        </div>
      </div>
      {loading ? <Loader /> : ""}
    </>
  );
}
